<app-title [title]="title"></app-title>

<div [class]="'scale ' + type">
  <div class="scale--lead">
    {{ lead }}
  </div>

  <div class="scale--header">
    <div class="empty"></div>
    <div class="answers">
      <div *ngFor="let a of answers">
        {{ a.text }}
      </div>
    </div>
  </div>

  <div class="scale--row" *ngFor="let s of scaleRows; let i = index">
    <div class="question">
      {{ s.question.text }} {{ required ? ' *' : '' }}
      <app-error-message
        *ngIf="selectedValues[i] === null && formControl.touched"
        [validationErrors]="required ? { required: true } : null"
      ></app-error-message>
    </div>
    <div class="answers">
      <div *ngFor="let a of s.answers" tabindex="0" class="ans" (keydown.space)="select($event, a.id, i)" (click)="select($event, a.id, i)" [class.disabled]="formControl.disabled">
        <div class="rad"><div [class.round]="isSelected(a.id, i.toString())"></div>
      </div>
      <div class="answer">{{ a.text }}</div>
      </div>
    </div>
  </div>
</div>
